module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.5edb31b.woff";